import React, { Component } from 'react'

// ui
import { Col } from 'antd'

// redux
import { connect } from 'react-redux'
import EventActions from '../../redux/component_select_event/actions'
import image from '../../resource/image/imgEventDefaul.jpg'

class EventComponent extends Component {
    _handleUpdateSelectEventState = () => {
        const { event } = this.props
        this.props.updateSelectEventState(event.event_id, !event.isSelect)
    }

    render() {
        const { event } = this.props
        const { isSelect, avatar } = event
        const color = isSelect ? 'lightgreen' : 'white'

        return (
            <Col className="EventComponentContainer" md={6} xs={8}>
                <div
                    className="EventComponent"
                    style={{ backgroundColor: color }}
                    onClick={() => this._handleUpdateSelectEventState()}
                >
                    <div className="AvatarImage">
                        <img alt="image" src={avatar !== '' ? avatar : image} />
                    </div>
                    <div className="EventBody">
                        <div className="EventName">{event.name}</div>
                    </div>
                </div>
            </Col>
        )
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        updateSelectEventState: (eid, selectState) => {
            dispatch(
                EventActions.action.updateSelectStateEvent(eid, selectState)
            )
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EventComponent)
